import { IProduct, Product } from './product';

export interface IRenewal extends IProduct {
    renewalYear: string;
    status: string;
    price: number;
    annualFeeCharityId: number;    
}

export class Renewal extends Product implements IRenewal {
    renewalYear: string;
    status: string;
    price: number;
    annualFeeCharityId: number;    
}
